import React,{useEffect, useState} from 'react';
import './warning.css';

function Warning({goNext}) {
  const [white, setWhite] = useState(0);
  const [clicked, setClicked] = useState(true);

  async function go(){

    await goo();


       function goo(){
            return new Promise( async (resolve, reject) => {
              setClicked(false);
              await changeWhite();
              goNext();
              resolve();
              });
            }

  }

  function changeWhite(toLow){
    return new Promise((resolve, reject) => {
    if(toLow){
      var op=1;
      change(toLow);
    }else{
      var op=0;
      change();
    }
    function change(toLow){
    if(toLow){
      if(op>0){
        op-=0.03;
      setWhite(op);
      setTimeout(ChangetoLow, 10);
    }else{
      resolve();
      return;
    }
  }else{
    if(op<1){
      op+=0.03;
    setWhite(op);
    setTimeout(change, 10);
  }else{
    resolve();
    return;
  }
  }

  function ChangetoLow(){
     change(true);
  }
  }
  });
  }

return(
<div className='blcwrap'>
<div className='clickWrap' onClick={clicked? go : undefined} id='wrap' style={{opacity:white}}></div>
<div className='txt1'>
<h1 style={{fontSize:"30px", color:"#ea4f2e"}}>18+</h1>
<h1 style={{fontSize:"25px", color:"#ea4f2e"}}>No minors allowed</h1>
<h2 style={{marginTop:"1vh"}}>All characters appearing in this work are fictitious and are 18 years old or above. Any resemblance to real persons, living or dead, is purely coincidental.</h2>
<br/>
<h2>Tap to continue</h2>
</div>
</div>
);

}

export default Warning;
